import { Box, IconButton, Typography } from "@mui/material";
import { LuInstagram, LuMail } from "react-icons/lu";
import { FaLinkedinIn } from "react-icons/fa";

const SocialMediaIcons = () => (
  <Box display="flex" alignItems="center" gap={4}>
    <a
      href="https://www.instagram.com/miraedesignhouse/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <IconButton
        sx={{
          color: "#FFF",
          backgroundColor: "#AE4034",
          "&:hover": {
            backgroundColor: "#343434",
          },
        }}
      >
        <LuInstagram size={20} />
      </IconButton>
    </a>
    <a
      href="https://in.linkedin.com/company/boketto-designs"
      target="_blank"
      rel="noopener noreferrer"
    >
      <IconButton
        sx={{
          color: "#FFF",
          backgroundColor: "#AE4034",
          "&:hover": {
            backgroundColor: "#343434",
          },
        }}
      >
        <FaLinkedinIn size={20} />
      </IconButton>
    </a>
    <a href="mailto:sakshi@themirae.in">
      <IconButton
        sx={{
          color: "#FFF",
          backgroundColor: "#AE4034",
          "&:hover": {
            backgroundColor: "#343434",
          },
        }}
      >
        <LuMail size={20} />
      </IconButton>
    </a>
  </Box>
);

const FollowUs = () => {
  return (
    <Box
      sx={{
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        my: 5,
      }}
    >
      <Typography variant="h2" mb={1.5}>
        Follow Miraé Designs
      </Typography>
      <SocialMediaIcons />
      <Typography my={1.5}>
        Copyright © Miraé Designs. All rights reserved.
      </Typography>
    </Box>
  );
};

export default FollowUs;
